<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol" aria-hidden="true">
    <path
      fill="currentColor"
      d="M23.4 5.9L18 .6c-.8-.8-2.3-.8-3.1 0L.7 14.9c-.2.2-.4.5-.5.7-.1.3-.2.6-.2.9v5.3c0 .6.2 1.1.6 1.6.4.4 1 .6 1.6.6h5.7c.3 0 .7-.1.9-.4L23.4 9.1c.4-.4.6-1 .6-1.6 0-.6-.2-1.1-.6-1.6zm-16 15.6H2.5v-4.8L12.7 6.5l4.9 4.9L7.4 21.5zm11.9-12l-4.9-4.9 2-2 4.9 4.9-2 2z"
    />
  </svg>
</template>
